import { useEffect } from "react";
import { IMG } from "@/data/site";
import { getPage, SITE } from "@/data/seoSchema";

type Seo = { title: string; description: string; schema?: Record<string, unknown>[]; noindex?: boolean };

function setMeta(attr: "name" | "property", key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.content = content;
}

export function useSeo({ title, description, schema, noindex }: Seo) {
  useEffect(() => {
    const url = SITE + window.location.pathname;
    document.title = title;
    setMeta("name", "description", description);
    setMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large");
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:url", url);
    setMeta("property", "og:image", IMG.hero);
    setMeta("property", "og:site_name", "All Concept Concrete");
    setMeta("property", "og:locale", "en_AU");
    setMeta("name", "twitter:card", "summary_large_image");
    let link = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.rel = "canonical";
      document.head.appendChild(link);
    }
    link.href = url;
    document.head.querySelectorAll('script[type="application/ld+json"]').forEach((s) => s.remove());
    (schema || []).forEach((obj) => {
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.text = JSON.stringify(obj);
      document.head.appendChild(script);
    });
  }, [title, description, schema, noindex]);
}

// Page SEO from the shared definitions used by the build-time prerender.
export function usePageSeo(path: string) {
  const p = getPage(path);
  useSeo(p ? { title: p.title, description: p.description, schema: p.schema } : { title: "Page not found | All Concept Concrete", description: "", noindex: true });
}
